import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import VideoPlayer from "../VideoPlayer";
import "./ContentPlayer.css";
import SideMenuItem from "../SideMenuItem/SideMenuItem";
import TileBar from "../TileBar";
import { useDispatch } from "react-redux";
import {
  getLessonData,
  getMskillLessons,
  sress,
  getSkillProgress,
  getTasks,
  getMskillProgress,
  shareUserBadge,
} from "../../../redux/actions/contentPayer";
import { useSelector } from "react-redux";
import "react-circular-progressbar/dist/styles.css";
import { getWatchedLessonsOfMskill } from "../../../redux/actions/contentPayer";
import {
  editLastPlayed,
  editLastPlayedCourse,
  getDiscountByActivity,
} from "../../../redux/actions/userActivity";
import { getPersonaliseUnlockedCourses, getPersonalizeUserData, getUserCourseNames } from "../../../redux/actions/personalize.js";
import { fetchIsUserFromBetaProduct } from "../../../redux/actions/personaliseCourse.js";
import ContentPlayerNavbar from "../ContentPlayerNavbar";
import ReactPixel from "react-facebook-pixel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faLongArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants, {
  discountActivity,
  leadScoringActivity,
} from "../../../common/constants";
import { getCourseById } from "../../../redux/actions/courses";
import { getMSkills, getSkill } from "../../../redux/actions/skills.js";
import ContentPlayerAccordian from "../ContentPlayerAccordian";
import Spinner from "../../../components/Spinner";
import Iconbar from "../Iconbar";
import Walkthrough from "../../../components/Walkthrough";
import {
  contentPlayerPageWalkthrough,
  contentPlayerPageWalkthroughMobile,
} from "../../../components/Walkthrough/WalkthroughData";
import {
  createLinkedinPost,
  editWalkthrough,
} from "../../../redux/actions/profileDetails";
import {
  checkUserAccess,
  getXanoAuthTokenFromUrl,
} from "../../../redux/actions/authentication";
import { toast } from "react-toastify";
import ToggleBtn from "./ToggleBtn";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { LINKEDIN_REDIRECT_URI } from "../../../config/api_config";
import DiscountModal from "../../../components/DiscountModal";
import Task from "../Task";
import {
  SET_IS_ACTIVATION,
  SET_LAST_CONTENT_PLAYED,
  SET_LAST_MSKILL_DURATION,
} from "../../../redux/actions/types";
import { createLeadScore } from "../../../redux/actions/pricing";
import { updateCertificateStatus } from "../../../redux/actions/certificate";
import ZohoSalesIQ from "../../../components/ZohoSalesIQ";
import useWindowSize from "../../../hooks/useWindowSize";
import GoogleOneTapLogin from "../../../components/GoogleOneTap";
import LearnDrawer from "../../../components/MobilePush/LearnDrawer.jsx";
import PricingBanner from "../../../components/banner/index.jsx";
import {
  shareAiNote,
  shareUserLearnings,
} from "../../../redux/actions/notes.js";
// import UpgradeToPremium from "../../../components/UpgradeToPremium";
export default function ContentPlayer() {
  const [playerDetails, setPlayerDetails] = useState(null);
  const [mskillData, setMskillData] = useState(null);
  const [skillData, setSkillData] = useState(null);

  const [watchedLessons, setWatchedLessons] = useState([]);
  const [videoProgressTime, setVideoProgressTime] = useState("00:00");
  const [tilebarItem, setTilebarItem] = useState("quiz");

  const [progress, setProgress] = useState(0);
  const [mskillProgressObject, setMskillProgressObject] = useState({});
  const [skillProgress, setSkillProgress] = useState(0);
  const [toggleSidebar, setToggleSideBar] = useState(true);
  const [courseCrumb, setCourseCrumb] = useState();
  const [tasks, setTasks] = useState([]);
  const [curTask, setCurTask] = useState(null);
  const [taskAction, setTaskAction] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [skillCrumb, setSkillCrumb] = useState();
  const [toggleQuizFocus, setToggleQuizFocus] = useState(false);
  const { width } = useWindowSize();
  const email = useSelector((store) => store?.profileDetails?.email);
  const is_activation = useSelector(
    (store) => store?.userActivity?.is_activation
  );

  const [discountForLessonAndComplete, setDiscountForLessonAndComplete] =
    useState({ open: false, data: null, modalType: null });
  // const [mskillCrumb, setMskillCrumb] = useState();
  // const [usePremiumModal, setUsePremiumModal] = useState(false)

  const courses_enrolled = useSelector(
    (store) => store?.userActivity?.user_enrolled_skills
  );
  const last_unlocked_certificate_image = useSelector(
    (store) => store?.userActivity?.last_unlocked_certificate_image
  );
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const walkthrough = useSelector(
    (store) => store?.profileDetails?.walkthrough
  );
  const last_challenge_certificate_id = useSelector(
    (store) => store?.userActivity?.challenge_certificate_id
  );
  const walkthroughData = useSelector(
    (store) => store?.userActivity?.walkthrough
  );
  const redirect_type = useSelector(
    (store) => store?.userActivity?.redirect_type
  );
  const playerRef = useRef();
  const quizRef = useRef();
  const sidebarRef = useRef();
  const mainRef = useRef();
  const scrollRef = useRef();

  const { course_slug, skill_slug, mskill_slug, contentId, new_user } =
    useParams();
  //console.log('the params' , {course_slug, skill_slug, mskill_slug, contentId, new_user });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deviceInfo, setDeviceInfo] = useState({
    is_android: false,
    browser_name: "default",
  });
  const isDesktop = window.innerWidth > 758 ? true : false;
  const openMobileModal = useSelector((store) => store?.appTheme?.blackOverlay);
  const [unlockedCourses, setUnlockedCourses] = useState(null);
  const [isBeta, setIsBeta] = useState(null);

  useEffect(() => {
    if (user_id) {
      dispatch(getPersonalizeUserData(email , (succesObj)=>{

        dispatch(getUserCourseNames(succesObj?.uid , succesObj?.access_token , (res)=>{
          setUnlockedCourses(res?.['subject_names'])
        } , (err)=>{}))

      },(erroObj)=>{}))
      dispatch(
        fetchIsUserFromBetaProduct((res) => {
          console.log("monday", res);
          if (
            res?.data?.is_ninjacurate_user ||
            res?.data?.ninjacurate_is_paid
          ) {
            setIsBeta(true);
          } else setIsBeta(false);
        })
      );
    }
  }, [user_id]);

  useEffect(() => {
    const { userAgent } = navigator;

    const getBrowserName = (userAgent) => {
      if (userAgent.indexOf("Firefox") > -1) {
        return "Firefox";
      } else if (
        userAgent.indexOf("Opera") > -1 ||
        userAgent.indexOf("OPR") > -1
      ) {
        return "Opera";
      } else if (userAgent.indexOf("Edg") > -1) {
        return "Edge";
      } else {
        return "Unknown";
      }
    };

    const getDeviceInfo = () => {
      const isAndroid = /Android/.test(userAgent);
      const browser = getBrowserName(userAgent);
      console.log("inside runner");
      setDeviceInfo((prev) => ({
        ...prev,
        is_android: isAndroid,
        browser_name: browser,
      }));
    };

    getDeviceInfo();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if(scrollRef?.current){
        scrollRef?.current?.scrollIntoView();
      }
    }, 10000);
  }, [mskill_slug, contentId]);

  useEffect(async () => {
    ReactPixel.pageView();
    ReactPixel.trackSingle("333999584825866", "View Content");
    Mixpanel.track(Constants.Mixpanel.CONTENT_PLAYER_VISIT);
    if (new_user && searchParams.get("lt_code")) {
      toast.success("Logging in Please Wait!");
      dispatch(
        getXanoAuthTokenFromUrl(
          "lt_code",
          searchParams.get("lt_code"),
          (successObj) => {
            if (successObj?.show_toast) {
              toast.error(successObj?.message);
            } else {
              navigate(
                `/${course_slug}/${skill_slug}/${mskill_slug}/${contentId}`,
                { replace: true }
              );
            }
          }
        )
      );
    }
    if (searchParams.get("linkedin_share")) {
      if (redirect_type?.type === "linkedin_content_player_notes") {
        dispatch(
          shareAiNote(
            redirect_type?.id,
            window.location.href,
            (successObj) => {
              if (successObj?.result === "success") {
                dispatch(
                  getLessonData(
                    contentId,
                    (res) => {
                      dispatch(
                        createLinkedinPost(
                          searchParams.get("code"),
                          LINKEDIN_REDIRECT_URI,
                          "AI Notes",
                          `I'm super excited to share my latest learnings. Check out my key insights from ${
                            res?.["lesson-name"]
                          }.
      
      I'm in the midst of an action packed course on ${
        res?.["skill-name"]
      } and I am Looking forward to share more such tips with you ${"\u{1F680}"}
      #learning #education #growth #careers #continuouslearning #professionalgrowth #learntube #motivation`,
                          successObj?.data,
                          (successobj) => {
                            Mixpanel.track(Constants.Mixpanel.LINKEDIN_SHARED, {
                              distinct_id: email,
                            });
                            toast.success(
                              "Note successfully shared to LinkedIn!"
                            );
                          }
                        )
                      );
                    },
                    () => {
                      navigate("/error");
                    }
                  )
                );
              } else {
                toast.error(successObj?.message);
              }
            },
            (error) => {
              toast.warn(error);
            }
          )
        );
      } else if (redirect_type?.type === "linkedin_content_player_badge") {
        dispatch(
          shareUserBadge(
            redirect_type?.id,
            window.location.href,
            (successObj) => {
              if (successObj?.result === "success") {
                dispatch(
                  getLessonData(
                    contentId,
                    (res) => {
                dispatch(
                  createLinkedinPost(
                    searchParams.get("code"),
                    LINKEDIN_REDIRECT_URI,
                    "AI Notes",
                    `New milestone unlocked!${"\u2728"}
Guess what, I've added one more awesome topic to my skills.
Just completed learning ${res?.['lesson-name']}. I am excited to implement this at work and continue growing in this ever evolving field!
#learning #onlineeducation #growth #careers #continuouslearning #professionalgrowth #learntube #getthingsdone`,
                    successObj?.data,
                    (successobj) => {
                      Mixpanel.track(Constants.Mixpanel.LINKEDIN_SHARED, {
                        distinct_id: email,
                      });
                      toast.success("Successfully shared to LinkedIn!");
                    }
                  )
                );
              },(err)=>{}))
              } else {
                toast.error(successObj?.message);
              }
            },
            (error) => {
              toast.warn(error);
            }
          )
        );
      } else if (redirect_type?.type === "linkedin_content_player_learnings") {
        dispatch(
          shareUserLearnings(
            redirect_type?.id,
            window.location.href,
            (successObj) => {
              if (successObj?.result === "success") {
                dispatch(
                  getLessonData(
                    contentId,
                    (res) => {
                dispatch(
                  createLinkedinPost(
                    searchParams.get("code"),
                    LINKEDIN_REDIRECT_URI,
                    "AI Notes",
                    `I'm super excited to share my latest learnings. Check out my key insights from ${
                            res?.["lesson-name"]
                          }.
      
      I'm in the midst of an action packed course on ${
        res?.["skill-name"]
      } and I am Looking forward to share more such tips with you ${"\u{1F680}"}
      #learning #education #growth #careers #continuouslearning #professionalgrowth #learntube #motivation`,
                    successObj?.data,
                    (successobj) => {
                      Mixpanel.track(Constants.Mixpanel.LINKEDIN_SHARED, {
                        distinct_id: email,
                      });
                      toast.success("Successfully shared to LinkedIn!");
                    }
                  )
                );
              },(err)=>{}))
              } else {
                toast.error(successObj?.message);
              }
            },
            (error) => {
              toast.warn(error);
            }
          )
        );
      } else {
        dispatch(
          updateCertificateStatus(last_challenge_certificate_id, "share")
        );
        dispatch(
          createLinkedinPost(
            searchParams.get("code"),
            LINKEDIN_REDIRECT_URI,
            "Certificate",
            "checkout this certificate i got from Learntube!",
            last_unlocked_certificate_image,
            (successobj) => {
              toast.success("Certificate successfully shared to LinkedIn!");
            }
          )
        );
      }
    }
  }, []);

  useEffect(async () => {
    setTimeout(async () => {
      // console.log("jojoj")
      await dispatch(
        getDiscountByActivity(
          user_id,
          discountActivity.MSKILL_ENROLLED.type,
          (successObj) => {
            console.log(successObj);
            if (successObj !== null) {
              setDiscountForLessonAndComplete((prev) => ({
                ...prev,
                open: true,
                modalType: discountActivity.MSKILL_ENROLLED,
                modalData: successObj,
              }));
            }
          }
        )
      );
    }, 5000);
  }, []);

  // console.log(discountForLessonAndComplete)

  useEffect(() => {
    if (
      user_id !== 0 &&
      user_id != null &&
      user_id != undefined &&
      is_activation
    ) {
      dispatch(
        checkUserAccess(
          (successObj) => {
            if (successObj?.is_activated === false) {
              dispatch({ type: SET_IS_ACTIVATION, payload: true });
            } else {
              dispatch({ type: SET_IS_ACTIVATION, payload: false });
            }
          },
          (err) => {}
        )
      );
    }
  }, [contentId]);
  console.log("This is Player details", playerDetails);
  useEffect(() => {
    if (contentId) {
      dispatch(
        getMSkills(skill_slug, user_id || 0, (successObj) =>
          setMskillData(successObj)
        )
      );
      dispatch(
        getSkill(user_id || 0, skill_slug, (successObj) => {
          setSkillData(successObj);
          setSkillCrumb({
            path: `/${course_slug}/${skill_slug}`,
            name: successObj["skill-name"],
          });
        })
      );
      dispatch(
        getLessonData(
          contentId,
          (successObj) => {
            dispatch(editLastPlayedCourse(successObj?.course_id));
            dispatch({
              type: SET_LAST_MSKILL_DURATION,
              payload: successObj?.["mskill_duration"],
            });
            setPlayerDetails(successObj);
            setCurTask(null);
          },
          () => {
            navigate("/error");
          }
        )
      );
      dispatch(editLastPlayed(user_id, contentId));
    } else {
      dispatch(
        getMSkills(skill_slug, user_id || 0, (successObj) =>
          setMskillData(successObj)
        )
      );
      dispatch(
        getSkill(user_id || 0, skill_slug, (successObj) => {
          setSkillData(successObj);
          setSkillCrumb({
            path: `/${course_slug}/${skill_slug}`,
            name: successObj["skill-name"],
          });
        })
      );
      dispatch(
        getMskillLessons(
          mskill_slug,
          (successObj) => {
            setPlayerDetails(successObj[0]);
            setCurTask(null);
          },
          () => {
            navigate("/error");
          }
        )
      );
    }

    dispatch(
      getWatchedLessonsOfMskill(user_id, mskill_slug, (successObj) => {
        setWatchedLessons(successObj);
      })
    );

    dispatch(
      getMskillProgress(user_id, mskill_slug, (successObj) => {
        setProgress(successObj.progress_by_completed.progress);
        setMskillProgressObject(successObj);
      })
    );

    dispatch(
      getSkillProgress(user_id, skill_slug, (successObj) => {
        setSkillProgress(successObj?.progress);
        if (successObj.progress == 100) {
          dispatch(
            createLeadScore(user_id, leadScoringActivity.COMPLETED_SKILL.type)
          );
        }
      })
    );

    dispatch(
      getCourseById(course_slug, (data) => {
        setCourseCrumb({
          path: `/${course_slug}`,
          name: data["course-name"].replace("Course", ""),
        });
      })
    );

    // dispatch(getSkill(user_id || 0, skill_slug, (data) => {

    // }));
  }, [contentId, mskill_slug]);

  console.log("playerDetails", { playerDetails });
  useEffect(() => {
    dispatch(
      getTasks(skill_slug, (successObj) => {
        setTasks(successObj);
      })
    );
  }, [skill_slug, curTask?.id, taskAction]);

  useEffect(() => {
    dispatch({
      type: SET_LAST_CONTENT_PLAYED,
      payload: window.location.pathname,
    });
  }, [skill_slug]);

  const isUserEnrolled = (course_slug, skill_slug) => {
    if (courses_enrolled?.length > 0) {
      const index = courses_enrolled.findIndex(
        (item) =>
          item.course_slug === course_slug && item.skill_slug === skill_slug
      );
      if (index < 0) return false;
      return true;
    }
    return false;
  };

  const getSecondsFromLocalString = (localTime) => {
    let time = localTime.split(":");
    let seconds;
    if (time.length === 2) {
      seconds = +time[0] * 60 + +time[1];
    } else if (time.length === 3) {
      seconds = +time[0] * 60 * 60 + +time[1] * 60 + +time[2];
    } else {
      seconds = 0;
    }
    return seconds;
  };

  const getlocalTimeStringFromSeconds = (seconds, playerRef) => {
    let timeDuration;
    if (playerRef?.current?.getDuration() > 3601) {
      timeDuration = new Date(seconds * 1000).toISOString().substr(11, 8);
    } else {
      timeDuration = new Date(seconds * 1000)
        .toISOString()
        .substr(11, 8)
        .slice(3);
    }
    return timeDuration;
  };

  const walkthroughHandler = (user_id, walkthroughObj) => {
    dispatch(editWalkthrough(user_id, walkthroughObj));
  };

  function getDuration(seconds) {
    // let time;
    if (seconds > 60) {
      if (seconds > 3600) {
        return `${(seconds / 3600).toFixed(1)} hours`;
      }
      return `${(seconds / 60).toFixed(0)} Min`;
    }
  }
  const handleTaskChange = (item) => {
    setCurTask(item);
  };
  console.log("ContentPlayer", progress);

  return playerDetails ? (
    <div
      ref={mainRef}
      className="fixed top-0 left-0 z-10 flex h-full w-full flex-col items-start justify-between overflow-y-scroll bg-white"
    >
      {user_id && <ZohoSalesIQ />}
      {!user_id && <GoogleOneTapLogin />}
      {openMobileModal?.showModal === true &&
      openMobileModal?.is_closed === false ? (
        <LearnDrawer deviceInfo={deviceInfo} />
      ) : (
        <PricingBanner deviceInfo={deviceInfo} />
      )}

      <div
        className={`flex h-screen w-full flex-col items-start justify-start pt-16 md:pt-16 ${
          toggleSidebar ? "md:w-9/12" : "md:w-full"
        } transition-all delay-300 ease-in-out`}
      >
        <div className="fixed top-0 left-0 z-10 w-full">
          <ContentPlayerNavbar
            progress={progress}
            playerDetails={playerDetails}
            mskill_slug={mskill_slug}
            quizRef={quizRef}
            mskillProgressObject={mskillProgressObject}
            skillProgress={skillProgress}
          />
        </div>

        {playerDetails && courseCrumb && skillCrumb ? (
          <div
            className={`flex w-full flex-col items-center justify-between transition-all delay-300 ease-in-out ${
              toggleQuizFocus && "flex-col-reverse"
            }`}
          >
            <div
              className={`${
                toggleSidebar ? "w-full" : "w-9/12"
              } flex flex-col items-center justify-between transition-all  delay-300 ease-in-out`}
            >
              {!curTask && (
                <>
                  <VideoPlayer
                    contentHeading={playerDetails["lesson-name"]}
                    levelID={playerDetails["level_id"]}
                    lessonId={playerDetails.id}
                    videoMetadata={playerDetails["lesson-description"]}
                    videoURL={playerDetails["lesson-videoLink"]}
                    setVideoProgressTime={setVideoProgressTime}
                    playerRef={playerRef}
                    getlocalTimeStringFromSeconds={
                      getlocalTimeStringFromSeconds
                    }
                    videoStartTime={playerDetails["lesson_start_time"]}
                    videoEndTime={playerDetails["lesson_stop_time"]}
                    setWatchedLessons={setWatchedLessons}
                    breadcrumbs={[
                      courseCrumb,
                      skillCrumb,
                      {
                        path: `/${course_slug}/${mskill_slug}/${playerDetails.id}}`,
                        name: playerDetails["lesson-name"],
                      },
                    ]}
                    videoDuration={playerDetails["video_duration"]}
                    videoThumbnail={playerDetails["lesson_videoThumbnail"]}
                  />
                  <Iconbar
                    videoURL={playerDetails["lesson-videoLink"]}
                    videoStartTime={playerDetails["lesson_start_time"]}
                    videoEndTime={playerDetails["lesson_stop_time"]}
                    videoDuration={playerDetails["video_duration"]}
                    playerDetails={playerDetails}
                    views={playerDetails["watch_count"]}
                  />
                </>
              )}
              {/* <Quiz lessonId={playerDetails?.id} /> */}
            </div>

            <div className="relative flex w-full flex-col items-center justify-between ">
              <TileBar
                playerDetails={playerDetails}
                videoProgressTime={videoProgressTime}
                playerRef={playerRef}
                isUserEnrolled={isUserEnrolled(course_slug, skill_slug)}
                getSecondsFromLocalString={getSecondsFromLocalString}
                getlocalTimeStringFromSeconds={getlocalTimeStringFromSeconds}
                tilebarItem={tilebarItem}
                setTilebarItem={setTilebarItem}
                setWatchedLessons={setWatchedLessons}
                watchedLessons={watchedLessons}
                setProgress={setProgress}
                quizRef={quizRef}
                mSkillProgress={progress}
                skillProgress={skillProgress}
                skillData={skillData}
                mskillData={mskillData}
                ToggleBtn={() => (
                  <ToggleBtn
                    toggleQuizFocus={toggleQuizFocus}
                    setToggleQuizFocus={() => {
                      mainRef?.current.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });

                      setToggleQuizFocus(!toggleQuizFocus);
                    }}
                  />
                )}
                mainRef={mainRef}
                setDiscountForLessonAndComplete={
                  setDiscountForLessonAndComplete
                }
                discountForLessonAndComplete={discountForLessonAndComplete}
                tasks={tasks}
                handleTaskChange={handleTaskChange}
                mskill_slug={mskill_slug}
                curTask={curTask}
                taskAction={taskAction}
                setTaskAction={setTaskAction}
                scrollRef={scrollRef}
                mskillProgressObject={mskillProgressObject}
                setMskillProgressObject={setMskillProgressObject}
                isBeta={isBeta}
                unlockedCourses={unlockedCourses}
              />
            </div>
          </div>
        ) : (
          <>
            <Spinner className="w-full flex h-screen flex-col justify-center items-center" />
          </>
        )}
      </div>
      <div
        className="group absolute top-20 right-0 hidden cursor-pointer items-center justify-center rounded-l border-y-2 border-l-2 border-slate-900 bg-slate-800 p-3 text-white transition-all delay-300 ease-in-out md:flex"
        onClick={() => setToggleSideBar(true)}
      >
        <FontAwesomeIcon icon={faLongArrowLeft} size={"lg"} />
      </div>
      <div
        className={`fixed top-0 h-screen w-3/12 pt-16 ${
          toggleSidebar ? "right-0" : "-right-full"
        } reactour-sidebar sidemenu-scrollbar hidden overflow-y-auto border-2 border-slate-100 bg-white px-2 text-[#454545] transition-all delay-300 ease-in-out md:block`}
      >
        <div className="relative flex h-20 w-full flex-row items-center justify-between">
          <div className="flex w-full items-center justify-between rounded p-2 px-4">
            <div>
              <h2
                className="cursor-pointer text-xs font-semibold text-gray-300"
                onClick={() => navigate(`/${course_slug}`)}
              >
                {skillData && skillData["course-name"]} &gt;
              </h2>
              <h1
                className="cursor-pointer font-bold"
                onClick={() => navigate(`/${course_slug}/${skill_slug}`)}
              >
                {skillData && skillData["skill-name"]}
              </h1>
            </div>
            <div className="h-11 w-11 font-bold">
              <CircularProgressbar
                value={skillProgress}
                text={`${skillProgress ? skillProgress : 0}%`}
                strokeWidth={12}
                styles={buildStyles({
                  textSize: "25px",
                  pathTransitionDuration: 0.5,
                  // Colors
                  pathColor: `#0BC128`,
                  textColor: "#000",
                  trailColor: "#BFFFC9",
                })}
              />
            </div>
          </div>
        </div>
        {mskillData &&
          mskillData?.map((mskill) => (
            <ContentPlayerAccordian
              // openUpgradeToPremium={() => setUsePremiumModal(true)}
              title={mskill["mSkill-name"]}
              id={mskill.mskill_slug}
              progress={progress}
              mskill={mskill}
            >
              <ul>
                <>
                  {mskill["lessons_of_mskill"].map((item) => (
                    <SideMenuItem
                      content={item}
                      active={item.id === playerDetails?.id && !curTask}
                      key={item.id}
                      tilebarItem={tilebarItem}
                      setTilebarItem={setTilebarItem}
                      setWatchedLessons={setWatchedLessons}
                      watchedLessons={watchedLessons}
                      quizRef={quizRef}
                      sidebarRef={sidebarRef}
                    />
                  ))}

                  {tasks
                    .filter((val) => val?.mskill_slug === mskill?.mskill_slug)
                    .map((item, id) => (
                      <SideMenuItem
                        // content={item}
                        active={item.id === curTask?.id}
                        key={item.id}
                        // tilebarItem={tilebarItem}
                        // setTilebarItem={setTilebarItem}
                        // setWatchedLessons={setWatchedLessons}
                        // watchedLessons={watchedLessons}
                        setTilebarItem={setTilebarItem}
                        quizRef={quizRef}
                        sidebarRef={sidebarRef}
                        handleTaskChange={() => handleTaskChange(item)}
                        task={item}
                        isTask
                      />
                    ))}
                </>
              </ul>
            </ContentPlayerAccordian>
          ))}
      </div>
      {!walkthrough?.content_player_walkthrough && (
        <Walkthrough
          tourOpen={true}
          steps={
            width > 768
              ? contentPlayerPageWalkthrough
              : contentPlayerPageWalkthroughMobile
          }
          onCloseFunction={[
            () =>
              walkthroughHandler(user_id, {
                ...walkthroughData,
                content_player_walkthrough: true,
              }),
          ]}
        />
      )}
      {/* <UpgradeToPremium openModal={usePremiumModal} onCloseFunction={() => setUsePremiumModal(false)} /> */}
      <DiscountModal
        openDiscountModal={discountForLessonAndComplete.open}
        setDiscountModal={setDiscountForLessonAndComplete}
        modalData={discountForLessonAndComplete.data}
        modalType={discountForLessonAndComplete.modalType}
      />
    </div>
  ) : (
    <div className="flex w-full h-screen flex-col justify-center items-center bg-white">
      <Spinner className="flex h-screen flex-col justify-center items-center" />
    </div>
  );
}

/* {
  courseCrumb && skillCrumb &&
    <div className="flex">
      <Breadcrumb crumbs={[courseCrumb, skillCrumb]} />
    </div>
} */
